import { Box, Typography } from "@mui/material";
import { useMemo } from "react";
import { slicePageItems } from "~/hooks/useDataGridPagination";
import { useWorkflowAssets } from "../hooks/useWorkflowAssets";
import WorkflowAssetsTable from "./WorkflowAssetTable/WorkflowAssetsTable";

export default function WorkflowAssets({
  workflowMrn,
}: {
  workflowMrn: string;
}) {
  const {
    loading,
    space,
    filters,
    assets,
    totalCount,
    paginationModel,
    onPaginationModelChange,
    rowCount,
  } = useWorkflowAssets({
    workflowMrn,
  });

  const rows = useMemo(() => {
    const { page, pageSize } = paginationModel;
    const pageAssets = slicePageItems(assets, page, pageSize);

    return pageAssets.map((a) => ({
      mrn: a.node?.mrn,
      risk_score: a.node?.score.riskRating,
      // logo: "aws",
      asset: a.node?.name,
      risk_factors: a.node?.riskFactors || [],
      lastUpdated: a.node?.updatedAt,
      url: `/space/inventory/${a.node?.id}/overview?spaceId=${space?.id}`,
    }));
  }, [assets, space?.id, paginationModel]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        alignSelf: "stretch",
        gap: 3,
      }}
    >
      <Typography variant="h4">
        Assets{" "}
        <Typography variant="h4" component="span" sx={{ fontWeight: "normal" }}>
          {totalCount} total
        </Typography>
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          alignSelf: "stretch",
          gap: 4,
        }}
      >
        <Box sx={{ width: 1 }}>{filters.filterForm}</Box>
        <WorkflowAssetsTable
          loading={loading}
          rows={rows}
          getRowId={(row) => row.mrn}
          paginationModel={paginationModel}
          onPaginationModelChange={onPaginationModelChange}
          rowCount={rowCount}
        />
      </Box>
    </Box>
  );
}
